import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const Chips = ({ options, value = [], onChange, single, testId }) => (
  <div className="st-chipset" data-testid={testId}>
    {options.map((o) => {
      const on = single ? value === o : value.includes(o);
      const next = single ? (on ? null : o) : on ? value.filter((v) => v !== o) : [...value, o];
      return <button key={o} type="button" className={`st-chip ${on ? "is-on" : ""}`} onClick={() => onChange(next)} data-testid={`${testId}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{o}</button>;
    })}
  </div>
);

export const Seg = ({ options, value, onChange, testId }) => (
  <div className="st-seg" data-testid={testId}>
    {options.map(([v, l]) => <button key={v} type="button" className={value === v ? "is-on" : ""} onClick={() => onChange(v)} data-testid={`${testId}-${v}`}>{l}</button>)}
  </div>
);

export const Q = ({ label, children, hint }) => (
  <div className="st-q"><span className="st-q__label">{label}</span>{children}{hint && <p className="st-muted st-small" style={{ margin: "8px 0 0" }}>{hint}</p>}</div>
);

export const Text = ({ value, onChange, placeholder, testId, area }) => (area
  ? <textarea className="st-input" style={{ height: 80, padding: 10, resize: "vertical" }} value={value || ""} placeholder={placeholder} maxLength={1500} onChange={(e) => onChange(e.target.value)} data-testid={testId} />
  : <input className="st-input" value={value || ""} placeholder={placeholder} maxLength={300} onChange={(e) => onChange(e.target.value)} data-testid={testId} />);

export const Block = ({ title, meta, children, defaultOpen, testId }) => {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <div className="st-block" data-testid={testId}>
      <button type="button" className="st-block__head" onClick={() => setOpen(!open)} aria-expanded={open} data-testid={`${testId}-toggle`}>
        <h3>{title}</h3>
        <span style={{ display: "flex", gap: 10, alignItems: "center" }} className="st-muted st-small">{meta}<ChevronDown size={16} style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform 0.2s ease" }} /></span>
      </button>
      {open && <div className="st-block__body">{children}</div>}
    </div>
  );
};

export const More = ({ label = "More details", children, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button type="button" className="st-more" onClick={() => setOpen(!open)} data-testid={testId}>{open ? "− Fewer details" : `+ ${label}`}</button>
      {open && <div style={{ display: "grid", gap: 4 }}>{children}</div>}
    </div>
  );
};

export const Slider = ({ left, right, value, onChange, testId }) => {
  const commit = (e) => { const v = Number(e.target.value); if (v !== value) onChange(v); };
  return (
    <div>
      <div className="st-slider">
        <span>{left}</span>
        <input type="range" min="0" max="100" step="5" value={value ?? 50} className={value == null ? "is-unset" : ""} onChange={commit} onPointerUp={commit} onTouchEnd={commit} onKeyUp={commit} data-testid={testId} />
        <span>{right}</span>
      </div>
      <p className="st-muted st-small" style={{ textAlign: "center", margin: "6px 0 0" }} data-testid={`${testId}-value`}>{value == null ? "Not set" : `${value} / 100`}</p>
    </div>
  );
};
